/*
 * Gymshark-style star rating on product cards, sourced live from Yotpo.
 *
 * Why JS: Yotpo is installed as theme app blocks only and does NOT sync ratings
 * into Shopify's `reviews.rating` metafields, so there is nothing for Liquid to
 * read at render time. This fetches the real bottomline per product and injects
 * a compact "★ 4.9" above the card title. If a product has no reviews, nothing
 * is rendered at all (matches Gymshark, where only some cards show a rating).
 *
 * Cost control: responses are ~100 bytes and cached in sessionStorage for the
 * session, so navigating around the store does not refetch. Cards are only
 * fetched when they scroll near the viewport.
 */
(function () {
  if (window.__egoCardRatings) return;
  window.__egoCardRatings = true;

  var APP_KEY = 'i0bvJPuDTBoUp3hKnYG2WP4xKfYgzQFcVjpvxxHl';
  var CACHE_PREFIX = 'ego_rating_';

  function cacheGet(pid) {
    try {
      var raw = sessionStorage.getItem(CACHE_PREFIX + pid);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function cacheSet(pid, data) {
    try {
      sessionStorage.setItem(CACHE_PREFIX + pid, JSON.stringify(data));
    } catch (e) {
      /* storage full or blocked — fine, we just refetch */
    }
  }

  // One decimal, but drop a trailing ".0" so 5.0 renders as "5" like Gymshark.
  function formatScore(score) {
    var rounded = Math.round(score * 10) / 10;
    return String(rounded).replace(/\.0$/, '');
  }

  function render(card, data, attempt) {
    if (!data || !data.count || card.querySelector('.ego-rating')) return;

    // Sit directly above the product title, inside the card's content column.
    // The content column can lag slightly behind the card element, and on a
    // warm sessionStorage cache this runs synchronously at init — early enough
    // that the title may not exist yet. Retry briefly rather than bailing.
    // NOTE: setTimeout, not requestAnimationFrame — rAF is paused entirely in
    // background tabs, so a card opened in a background tab would never render.
    var titleLink = card.querySelector('.group-block-content a');
    if (!titleLink || !titleLink.parentNode) {
      var tries = attempt || 0;
      if (tries < 20) {
        setTimeout(function () {
          render(card, data, tries + 1);
        }, 50);
      }
      return;
    }

    var el = document.createElement('div');
    el.className = 'ego-rating';
    el.setAttribute('aria-label', data.score + ' out of 5 stars, ' + data.count + ' reviews');
    el.innerHTML =
      '<svg class="ego-rating__star" viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
      '<path d="M10 1.5l2.6 5.3 5.9.85-4.25 4.15 1 5.85L10 14.9l-5.25 2.75 1-5.85L1.5 7.65l5.9-.85z"/>' +
      '</svg><span>' + formatScore(data.score) + '</span>';
    titleLink.parentNode.insertBefore(el, titleLink);
  }

  function load(card) {
    var tag = card.querySelector('[data-ego-pid]');
    if (!tag) return;
    var pid = tag.getAttribute('data-ego-pid');
    if (!pid) return;

    var cached = cacheGet(pid);
    if (cached) {
      render(card, cached);
      return;
    }

    fetch('https://api-cdn.yotpo.com/v1/widget/' + APP_KEY + '/products/' + pid + '/reviews.json')
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (json) {
        var bl = (json && json.response && json.response.bottomline) || {};
        var data = {
          count: bl.total_review || 0,
          score: bl.average_score || 0,
        };
        cacheSet(pid, data);
        render(card, data);
      })
      .catch(function () {
        /* Yotpo unreachable — card simply shows no rating. */
      });
  }

  // Paint anything we already know about, without waiting on the observer.
  // IntersectionObserver callbacks do not run while a tab is hidden, so a page
  // opened in a background tab (or restored from bfcache) would otherwise sit
  // blank until it was scrolled. This costs no network — cache reads only.
  function renderCached() {
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card.querySelector('.ego-rating')) return;
      var tag = card.querySelector('[data-ego-pid]');
      if (!tag) return;
      var cached = cacheGet(tag.getAttribute('data-ego-pid'));
      if (cached) render(card, cached);
    });
  }

  function init() {
    var cards = document.querySelectorAll('product-card');
    if (!cards.length) return;

    renderCached();

    if (!('IntersectionObserver' in window)) {
      cards.forEach(load);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          load(entry.target);
        });
      },
      { rootMargin: '300px' }
    );

    cards.forEach(function (c) {
      io.observe(c);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Catch up once the tab is actually shown (observer was dormant until now).
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') init();
  });
  window.addEventListener('pageshow', init);

  // Collection filtering / pagination swaps cards in without a page load.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
